import React, {useState} from 'react';
import {AppBar, Box, Toolbar, Typography} from '@mui/material';
import {Link} from 'react-router-dom';
import {useTheme} from '@mui/material/styles';
import HamburgerToXButton from "./HamburgerMenu";

const NavBar = () => {
  const theme = useTheme
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Box sx={{ flexGrow: 1}}>
      <AppBar position='fixed' sx={{zIndex: 1100}}>
        <Toolbar>
          <Link to='/mhdweb2'>
            <img src={`${process.env.PUBLIC_URL}/psi_logo.png`}
                 alt='MHDweb'
                 style={{ width: '40px', marginRight: '10px', transition: 'transform 0.2s'}}
                 onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'scale(1.2)';
                  }}
                 onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
            />
          </Link>

          <Typography component='div' sx={{ flexGrow: 1, color: 'text.light', fontSize: '20px', fontFamily: 'Share' }}>
            MHDweb
          </Typography>

          <HamburgerToXButton />

        </Toolbar>
      </AppBar>
    </Box>
  );
};


export { NavBar };